import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetJson } from '../helpers/fetchReact';
import { REST_API } from '../constants';
import { STATE_STATUS } from '../constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';

const initialState = {
  graphVisualizationTypes: [],
  graphVisualizationType: null,
  graphVisualizationTypeLoading: STATE_STATUS.IDLE,
  graphVisualizationTypeError: null,
  standardgraphaxises: [],
  standardgraphaxis: {},
  standardgraphaxisLoading: STATE_STATUS.IDLE,
  standardgraphaxisError: null,
  unitofmeasures: [],
  unitofmeasure: {},
  unitofmeasureLoading: STATE_STATUS.IDLE,
  unitofmeasureError: null,
  dataTypes: [],
  dataType: {},
  dataTypeLoading: STATE_STATUS.IDLE,
  dataTypeError: null,
  transformTypes: [],
  transformType: {},
  transformTypeLoading: STATE_STATUS.IDLE,
  transformTypeError: null,
};

export const selectAllGraphVisualizationTypes = (state) => state.observationTypeStatuses.graphVisualizationTypes;
export const selectGraphVisualizationTypeId = (state) => state.observationTypeStatuses.graphVisualizationType.Id;
export const selectAllStandardgraphaxises = (state) => state.observationTypeStatuses.standardgraphaxises;
export const selectStandardgraphaxisId = (state) => state.observationTypeStatuses.standardgraphaxis.Id;
export const selectAllUnitofmeasures = (state) => state.observationTypeStatuses.unitofmeasures;
export const selectUnitofmeasureId = (state) => state.observationTypeStatuses.unitofmeasure.Id;
export const selectAllDataTypes = (state) => state.observationTypeStatuses.dataTypes;
export const selectDataTypeId = (state) => state.observationTypeStatuses.dataType.Id;
export const selectAllTransformTypes = (state) => state.observationTypeStatuses.transformTypes;
export const selectTransformTypeId = (state) => state.observationTypeStatuses.transformType.Id;

export const getGraphVisualizationTypeLoading = (state) => state.observationTypeStatuses.graphVisualizationTypeLoading;
export const getStandardgraphaxisLoading = (state) => state.observationTypeStatuses.standardgraphaxisLoading;
export const getUnitofmeasureLoading = (state) => state.observationTypeStatuses.unitofmeasureLoading;
export const getDataTypeLoading = (state) => state.observationTypeStatuses.dataTypeLoading;
export const getTransformTypeLoading = (state) => state.observationTypeStatuses.transformTypeLoading;

export const fetchGraphVisualizationTypes = createAsyncThunk(
  'observationTypeStatuses/fetchGraphVisualizationTypes',
  async () => {
    const url = REST_API.OBSERVATION_TYPES + 'graphvisualizationtypes';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { observationTypeStatuses: state } = getState();
      return state.graphVisualizationTypeLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchStandardgraphaxises = createAsyncThunk(
  'observationTypeStatuses/fetchStandardgraphaxises',
  async () => {
    const url = REST_API.STANDARD_GRAPH_AXIS;

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { observationTypeStatuses: state } = getState();
      return state.standardgraphaxisLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const createStandardgraphaxis = createAsyncThunk(
  'observationTypeStatuses/createStandardgraphaxis',
  async (entityDto) => entityDto,
  {
    condition: (args, { getState }) => {
      const { observationTypeStatuses: state } = getState();

      return state.standardgraphaxisLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchUnitofmeasures = createAsyncThunk(
  'observationTypeStatuses/fetchUnitofmeasures',
  async () => {
    const url = REST_API.OBSERVATION_TYPES + 'unitofmeasures';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { observationTypeStatuses: state } = getState();
      return state.unitofmeasureLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchDataTypes = createAsyncThunk(
  'observationTypeStatuses/fetchDataTypes',
  async () => {
    const url = REST_API.OBSERVATION_TYPES + 'wagdatatypes';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { observationTypeStatuses: state } = getState();
      return state.dataTypeLoading !== STATE_STATUS.LOADING;
    },
  },
);

export const fetchTransformTypes = createAsyncThunk(
  'observationTypeStatuses/fetchTransformTypes',
  async () => {
    const url = REST_API.OBSERVATION_TYPES + 'visualvaluetransformtypes';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { observationTypeStatuses: state } = getState();
      return state.transformtypeLoading !== STATE_STATUS.LOADING;
    },
  },
);

export const observationTypeStatusesSlice = createSlice({
  name: 'observationTypeStatuses',
  initialState,
  reducers: {
    setGraphVisualizationType(state, action) {
      state.graphVisualizationType = action.payload;
    },
    setStandardgraphaxis(state, action) {
      state.standardgraphaxis = action.payload;
    },
    setUnitofmeasure(state, action) {
      state.unitofmeasure = action.payload;
    },
    setDataType(state, action) {
      state.dataType = action.payload;
    },
    setTransformtype(state, action) {
      state.transformType = action.payload;
    },
  },
  extraReducers: {
    [fetchGraphVisualizationTypes.pending]: (state) => {
      state.graphVisualizationTypeLoading = STATE_STATUS.LOADING;
    },
    [fetchGraphVisualizationTypes.fulfilled]: (state, action) => {
      state.graphVisualizationTypeLoading = STATE_STATUS.SUCCESS;

      state.graphVisualizationTypes = action.payload;
      if (isValueEmpty(state.graphVisualizationType) || state.graphVisualizationType.Id < 1) {
        let defaultGvt = state.graphVisualizationTypes.find((gvt) => (gvt.Name + '').toLowerCase() == 'line');
        state.graphVisualizationType = { ...defaultGvt };
      }
    },
    [fetchGraphVisualizationTypes.rejected]: (state, action) => {
      state.graphVisualizationTypeLoading = STATE_STATUS.FAILED;
      state.graphVisualizationTypeError = action.error.message;
    },

    [fetchStandardgraphaxises.pending]: (state) => {
      state.standardgraphaxisLoading = STATE_STATUS.LOADING;
    },
    [fetchStandardgraphaxises.fulfilled]: (state, action) => {
      state.standardgraphaxisLoading = STATE_STATUS.SUCCESS;

      let _types = action.payload;
      let nullableTypes = [];
      nullableTypes.push({ Description: '', DropdownText: '		', Id: 0, Name: ' ' });
      _types.map((t) => {
        nullableTypes.push(t);
      });
      state.standardgraphaxises = nullableTypes;
    },
    [fetchStandardgraphaxises.rejected]: (state, action) => {
      state.standardgraphaxisLoading = STATE_STATUS.FAILED;
      state.standardgraphaxisError = action.error.message;
    },
    [createStandardgraphaxis.pending]: (state) => {
      state.standardgraphaxisLoading = STATE_STATUS.LOADING;
    },
    [createStandardgraphaxis.fulfilled]: (state, action) => {
      state.standardgraphaxises.push(action.payload);

      state.standardgraphaxis = action.payload;

      state.standardgraphaxisLoading = STATE_STATUS.SUCCESS;
    },
    [fetchUnitofmeasures.pending]: (state) => {
      state.unitofmeasureLoading = STATE_STATUS.LOADING;
    },
    [fetchUnitofmeasures.fulfilled]: (state, action) => {
      state.unitofmeasureLoading = STATE_STATUS.SUCCESS;

      let _unitofmeasures = action.payload;

      let nullableUnitofmeasures = [];
      nullableUnitofmeasures.push({ DropdownText: '', Id: 0, IsActive: true, Name: '', Number: 0 });
      _unitofmeasures.map((t) => {
        nullableUnitofmeasures.push(t);
      });
      state.unitofmeasures = nullableUnitofmeasures;
    },
    [fetchUnitofmeasures.rejected]: (state, action) => {
      state.unitofmeasureLoading = STATE_STATUS.FAILED;
      state.unitofmeasureError = action.error.message;
    },

    [fetchDataTypes.pending]: (state) => {
      state.dataTypeLoading = STATE_STATUS.LOADING;
    },
    [fetchDataTypes.fulfilled]: (state, action) => {
      state.dataTypeLoading = STATE_STATUS.SUCCESS;
      state.dataTypes = action.payload;
    },
    [fetchDataTypes.rejected]: (state, action) => {
      state.dataTypeLoading = STATE_STATUS.FAILED;
      state.dataTypeError = action.error.message;
    },

    [fetchTransformTypes.pending]: (state) => {
      state.transformTypeLoading = STATE_STATUS.LOADING;
    },
    [fetchTransformTypes.fulfilled]: (state, action) => {
      state.transformTypeLoading = STATE_STATUS.SUCCESS;
      let _transformtypes = action.payload;
      let nullableTransformTypes = [];
      nullableTransformTypes.push({ Description: '', DropdownText: '', Id: null, Name: '' });
      _transformtypes.map((t) => {
        nullableTransformTypes.push(t);
      });
      state.transformTypes = nullableTransformTypes;
    },
    [fetchTransformTypes.rejected]: (state, action) => {
      state.transformTypeLoading = STATE_STATUS.FAILED;
      state.transformTypeError = action.error.message;
    },
  },
});

export const { setGraphVisualizationType, setStandardgraphaxis, setUnitofmeasure, setDataType, setTransformType } =
  observationTypeStatusesSlice.actions;
